const CONSENT_EVENTS = ["CookiebotOnConsentReady", "CookiebotOnAccept"];

/**
 * Runs `callback` once the visitor has consented to a Cookiebot category.
 *
 * Runs immediately when consent is already known, otherwise waits for
 * Cookiebot to report it (a stored consent on load, or the visitor accepting
 * the banner). Never runs if the visitor doesn't consent. Mirrors the gating
 * in `public/js/third-party-loader.js` for tags that are initialised from
 * React rather than from the loader.
 *
 * @param {"preferences"|"statistics"|"marketing"} category - Cookiebot consent category
 * @param {Function} callback - Called at most once
 *
 * @example
 * onCookieConsent("marketing", () => ReactPixel.init(PIXEL_ID));
 */
export const onCookieConsent = (category, callback) => {
  let hasRun = false;
  const runIfConsented = () => {
    if (hasRun || !window.Cookiebot?.consent?.[category]) return;
    hasRun = true;
    CONSENT_EVENTS.forEach((eventName) => window.removeEventListener(eventName, runIfConsented));
    callback();
  };
  CONSENT_EVENTS.forEach((eventName) => window.addEventListener(eventName, runIfConsented));
  runIfConsented();
};
